import React, { useEffect, useRef } from "react";

import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import { isResultRevealingSpec } from "../../../../../grace-period/utils";
import { SPEC_FLAGS_MAP } from "../../../../../Common/constants/SpecFlagConstants";

import { ReactComponent as StatusDotIcon } from "../../../../../../assets/images/environment/statusPingDot.svg";
import "./FilterButtons.css";

const CLEARED_FILTER = -1;

const FilterButtons = ({
  handleSelectFilter,
  filterSelected,
  greyout,
}) => {
  const { areResultsLocked } = useAccessStatus();
  const handleSelectFilterRef = useRef(handleSelectFilter);
  const pendingResetRef = useRef(false);

  handleSelectFilterRef.current = handleSelectFilter;

  useEffect(() => {
    if (greyout || !areResultsLocked) {
      pendingResetRef.current = false;
      return;
    }

    const needsReset = isResultRevealingSpec(filterSelected);
    if (!needsReset) {
      pendingResetRef.current = false;
      return;
    }

    if (pendingResetRef.current) {
      return;
    }

    pendingResetRef.current = true;
    handleSelectFilterRef.current(CLEARED_FILTER);
  }, [areResultsLocked, filterSelected, greyout]);

  return (
    <div className="FilterButtons">
      { !greyout && [2, 1, 0].map((spec) => {
        const locked = areResultsLocked && spec !== 0;
        return (
          <div
            key={spec}
            className={`FilterButtons__Btn ${filterSelected === spec ? "FilterButtons__Btn--selected" : ""} ${locked ? "FilterButtons__Btn--locked" : ""}`}
            onClick={locked ? undefined : () => handleSelectFilter(spec)}
          >
            <StatusDotIcon width={15} height={15} fill={SPEC_FLAGS_MAP[spec].color} />
            <div className="FilterButtons__Text">{SPEC_FLAGS_MAP[spec].label}</div>
          </div>
        );
      })}
      { greyout && [2, 1, 0].map((spec) => (
        <div
          key={spec}
          className={`FilterButtons__GrayOutBtn ${filterSelected === spec ? "FilterButtons__GrayOutBtn--selected" : ""}`}
          onClick={() => handleSelectFilter(spec)}
        >
          <StatusDotIcon width={15} height={15} fill={SPEC_FLAGS_MAP[spec].color} />
          <div className="FilterButtons__Text">{SPEC_FLAGS_MAP[spec].label}</div>
        </div>
      ))}
    </div>
  );
};

export default FilterButtons;
